import { useMutation, useQueryClient } from "@tanstack/react-query";
import { httpRequest } from "@/lib";
import { RequestProviderResponse } from "@/types";

export type CreateProviderRequestDTO = {
  name: string;
  phone: string;
  cnpj: string;
  cpf: string;
  address: string;
  comments: string;
  name_of_person_responsible: string;
  phone_person_responsible: string;
};

async function createProvider(
  request: CreateProviderRequestDTO
): Promise<RequestProviderResponse> {
  const response = await httpRequest.post<RequestProviderResponse>(
    "/providers",
    request
  );
  return response.data;
}

export function useCreateProviderMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: createProvider,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["providers"] });
    },
  });
}
